const brandModels = {

  Apple: [
    "iPhone X","iPhone XR","iPhone XS","iPhone XS Max",
    "iPhone 11","iPhone 11 Pro","iPhone 11 Pro Max",
    "iPhone 12","iPhone 12 Mini","iPhone 12 Pro","iPhone 12 Pro Max",
    "iPhone 13","iPhone 13 Mini","iPhone 13 Pro","iPhone 13 Pro Max",
    "iPhone 14","iPhone 14 Plus","iPhone 14 Pro","iPhone 14 Pro Max",
    "iPhone 15","iPhone 15 Plus","iPhone 15 Pro","iPhone 15 Pro Max",
    "iPhone 16","iPhone 16 Plus","iPhone 16 Pro","iPhone 16 Pro Max","iPhone 16e",
    "iPhone 17","iPhone 17 Air","iPhone 17 Pro","iPhone 17 Pro Max"
  ],

  Samsung: [
    "Galaxy A12","Galaxy A14 4G","Galaxy A14 5G","Galaxy A15","Galaxy A17 5G",
    "Galaxy A22 5G","Galaxy A23","Galaxy A25","Galaxy A26","Galaxy A30s","Galaxy A31",
    "Galaxy A33 5G","Galaxy A34 5G","Galaxy A35","Galaxy A50","Galaxy A51","Galaxy A52",
    "Galaxy A52 5G","Galaxy A52s 5G","Galaxy A53 5G","Galaxy A54 5G","Galaxy A55",
    "Galaxy A73 5G","Galaxy A81","Galaxy A91",
    "Galaxy F12","Galaxy F14 5G","Galaxy F23 5G","Galaxy F34 5G","Galaxy F36 5G",
    "Galaxy F41","Galaxy F42 5G","Galaxy F54 5G","Galaxy F62",
    "Galaxy M12","Galaxy M14","Galaxy M31","Galaxy M31 Prime","Galaxy M31s","Galaxy M32",
    "Galaxy M33 5G","Galaxy M34 5G","Galaxy M35 5G","Galaxy M36 5G","Galaxy M51",
    "Galaxy M53 5G","Galaxy M54 5G","Galaxy M62",
    "Galaxy S10 Lite","Galaxy S10 Plus","Galaxy Note 10 Lite","Galaxy Note 20 Ultra",
    "Galaxy S20 FE","Galaxy S20 FE 5G",
    "Galaxy S21","Galaxy S21 FE","Galaxy S21 Ultra",
    "Galaxy S22 5G","Galaxy S22 Plus 5G","Galaxy S22 Ultra 5G",
    "Galaxy S23","Galaxy S23 FE","Galaxy S23 Plus","Galaxy S23 Ultra",
    "Galaxy S24","Galaxy S24 FE","Galaxy S24 Plus","Galaxy S24 Ultra",
    "Galaxy S25","Galaxy S25 FE","Galaxy S25 Plus","Galaxy S25 Ultra","Galaxy S25 Edge"
  ],

  Google: [
    "Pixel 6","Pixel 6 Pro","Pixel 6a",
    "Pixel 7","Pixel 7 Pro","Pixel 7a",
    "Pixel 8","Pixel 8 Pro","Pixel 8a",
    "Pixel 9","Pixel 9 Pro","Pixel 9 Pro XL",
    "Pixel 10","Pixel 10 Pro","Pixel 10 Pro XL"
  ],

  OnePlus: [
    "OnePlus 6T","OnePlus 7","OnePlus 7 Pro","OnePlus 7T","OnePlus 7T Pro",
    "OnePlus 8","OnePlus 8 Pro","OnePlus 8T",
    "OnePlus 9","OnePlus 9 Pro","OnePlus 9R","OnePlus 9RT",
    "OnePlus 10 Pro","OnePlus 10R","OnePlus 10T",
    "OnePlus 11","OnePlus 11R",
    "OnePlus 12","OnePlus 12R",
    "OnePlus 13","OnePlus 13R","OnePlus 15",
    "OnePlus Nord","OnePlus Nord 2","OnePlus Nord 2T","OnePlus Nord 3",
    "OnePlus Nord 4","OnePlus Nord 5",
    "OnePlus Nord CE","OnePlus Nord CE 2","OnePlus Nord CE 2 Lite",
    "OnePlus Nord CE 3","OnePlus Nord CE 3 Lite",
    "OnePlus Nord CE 4","OnePlus Nord CE 4 Lite","OnePlus Nord CE 5",
    "OnePlus Ace","OnePlus Ace 2","OnePlus Ace 2V"
  ],

  Nothing: [
    "Nothing Phone (1)","Nothing Phone (2)","Nothing Phone (2a)",
    "Nothing Phone (3a)","Nothing Phone (3a) Pro",
    "CMF Phone (1)"
  ],

  Poco: [
    "Poco C3","Poco C31","Poco C50","Poco C55",
    "Poco F1","Poco F2 Pro","Poco F3","Poco F3 GT","Poco F4","Poco F5","Poco F6",
    "Poco M2","Poco M2 Pro","Poco M2 Reloaded","Poco M3","Poco M3 Pro",
    "Poco M4","Poco M4 Pro","Poco M5","Poco M6 Pro",
    "Poco X2","Poco X3","Poco X3 Pro","Poco X4 Pro","Poco X5 Pro","Poco X6"
  ],

  Oppo: [
    "Oppo Reno 6","Oppo Reno 7 Pro","Oppo Reno 8","Oppo Reno 8T",
    "Oppo Reno 10","Oppo Reno 10 Pro","Oppo Reno 10 Pro Plus",
    "Oppo Reno 12",
    "Oppo F23","Oppo K13",
    "Oppo A74","Oppo A78","Oppo A79","Oppo A58","Oppo A58X","Oppo A3 Pro"
  ],

  Vivo: [
    "Vivo X80 Lite","Vivo X90","Vivo X90 Pro","Vivo X200 FE",
    "Vivo Y22s","Vivo Y27","Vivo Y27 Pro","Vivo Y29","Vivo Y29 Pro",
    "Vivo Y33s","Vivo Y52","Vivo Y56","Vivo Y58","Vivo Y72","Vivo Y75s",
    "Vivo Y100","Vivo Y100a","Vivo Y200","Vivo Y200e",
    "Vivo Y300","Vivo Y300 Plus",
    "Vivo V20 Pro","Vivo V21","Vivo V21s","Vivo V23","Vivo V23 Pro",
    "Vivo V25","Vivo V25e","Vivo V25 Pro",
    "Vivo V27","Vivo V27 Pro",
    "Vivo V29","Vivo V29e","Vivo V29 Pro",
    "Vivo V30","Vivo V50",
    "Vivo T1","Vivo T1 Pro","Vivo T2","Vivo T2 Pro","Vivo T3",
    "Vivo S12","Vivo S12 Pro","Vivo S15e","Vivo S15 Pro","Vivo S16","Vivo S16 Pro"
  ],

  Xiaomi: [
    "Redmi 12","Redmi 12 5G","Redmi 13C",
    "Redmi Note 8 Pro","Redmi Note 9 Pro","Redmi Note 9 Pro Max",
    "Redmi Note 10","Redmi Note 10 Lite","Redmi Note 10 Pro","Redmi Note 10 Pro Max",
    "Redmi Note 11","Redmi Note 11 SE","Redmi Note 11 Pro","Redmi Note 11 Pro Plus",
    "Redmi Note 11T","Redmi Note 11T Pro","Redmi Note 11T Pro Plus",
    "Redmi Note 12","Redmi Note 12 Pro","Redmi Note 12 Pro Plus",
    "Redmi Note 13","Redmi Note 13 Pro","Redmi Note 13 Pro Plus",
    "Redmi Note 14","Redmi Note 14 Pro","Redmi Note 14 Pro Plus",
    "Redmi K20","Redmi K20 Pro","Redmi K40","Redmi K40 Gaming","Redmi K50i",
    "Mi 9T","Mi 9T Pro","Mi 10i","Mi 10T Lite",
    "Mi 11X","Mi 11X Pro","Mi 12","Mi 12X",
    "Xiaomi 11i","Xiaomi 11i HyperCharge","Xiaomi 13 Pro"
  ],

  Realme: [
    "Realme 7","Realme 7 Pro","Realme 8","Realme 8 Pro","Realme 8s",
    "Realme 9","Realme 9 Pro","Realme 9 Pro Plus",
    "Realme 10 Pro","Realme 10 Pro Plus",
    "Realme 11","Realme 11 Pro","Realme 11 Pro Plus","Realme 11X",
    "Realme 12","Realme 12 Pro","Realme 12 Pro Plus",
    "Realme 13 Pro Plus","Realme 14X","Realme 14 Pro","Realme 14 Pro Plus",
    "Realme 15","Realme 15 Pro",
    "Realme GT","Realme GT 2","Realme GT 6","Realme GT Pro",
    "Realme GT Neo 2","Realme GT Neo 2T","Realme GT Neo 3","Realme GT Neo 3T",
    "Realme Narzo 20 Pro","Realme Narzo 30","Realme Narzo 50 Pro",
    "Realme Narzo 60","Realme Narzo 60X",
    "Realme X7 Max","Realme P1",
    "Realme Q3","Realme Q3i","Realme Q3 Pro","Realme Q5","Realme Q5 Pro",
    "Realme V13","Realme V25"
  ],

  iQOO: [
    "iQOO 7","iQOO 7 Legend","iQOO 8",
    "iQOO 9","iQOO 9 Pro","iQOO 9 SE","iQOO 9T",
    "iQOO 11","iQOO 12","iQOO 13",
    "iQOO Neo 3","iQOO Neo 6","iQOO Neo 7","iQOO Neo 7 Pro","iQOO Neo 9 Pro",
    "iQOO Z1","iQOO Z3","iQOO Z5","iQOO Z6","iQOO Z6 Lite",
    "iQOO Z6 Pro","iQOO Z7","iQOO Z7 Pro","iQOO Z9","iQOO Z9X"
  ],

  Motorola: [
    "Moto G45","Moto G54","Moto G84",
    "Motorola Edge 30","Motorola Edge 30 Fusion","Motorola Edge 30 Ultra",
    "Motorola Edge 40","Motorola Edge 40 Neo",
    "Motorola Edge 50","Motorola Edge 50 Fusion",
    "Motorola Edge 60 Pro"
  ]
};
